import { List } from "@material-ui/core";
import { Link } from "@material-ui/icons";
import { ListItemLink } from "./ListItemLink";
import { useDispatch } from "react-redux";
import { resetPaging } from "../features/installedAppManager/InstalledAppSlice";

export const AppManagerSideMenu = () => {
  const dispatch = useDispatch();

  return (
    <>
      <List component="nav">
        <div onClick={() => dispatch(resetPaging())}>
          <ListItemLink
            to="/manager/installed-applications"
            primary="連携アプリ"
            icon={<Link />}
          />
        </div>
      </List>
    </>
  );
};
